
<button mat-icon-button [matMenuTriggerFor]="menuUserInfo"
        class="se-header-toolbar-button se-header-toolbar-user-info-button"
        [matTooltip]="userInitials  | async">
    <mat-icon>person</mat-icon>
</button>

<mat-menu #menuUserInfo="matMenu" yPosition="below" xPosition="before" class="se-mat-menu">

    <button mat-menu-item class="se-header-toolbar-item-info se-menu-button" *ngIf="!!completeName" disabled>
        <mat-icon>account_circle</mat-icon>
        <span translate>Name</span><span>: {{completeName}}</span>
    </button>
    <button mat-menu-item class="se-header-toolbar-item-info se-menu-button" *ngIf="!!estensaUser?.descName" disabled>
        <mat-icon [matTooltip]="estensaUser.description"  [matTooltipDisabled]="!!!estensaUser.description">info</mat-icon>
        <span translate>User</span><span>: {{estensaUser.descName}}</span>
    </button>
    <button mat-menu-item class="se-header-toolbar-item-info se-menu-button" *ngIf="!!userDomainName" disabled>
        <mat-icon>desktop_windows</mat-icon>
        <span translate>Domain</span><span>: {{userDomainName}}</span>
    </button>
    <button mat-menu-item class="se-menu-button" (click)="onLogoutClick()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
    </button>
</mat-menu>
